import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import DesignationCreateView from '../../../components/payroll/setup/designation/DesignationCreateView';
import DesignationListView from '../../../components/payroll/setup/designation/DesignationListView';

const DesignationCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.PayrollURL + 'payroll/designation/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <DesignationCreateView handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <DesignationListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default DesignationCreateListView